/**
 * How a pressed control names itself in analytics.
 *
 * Lives apart from `usePressCapture` so the rule can be tested on its own:
 * the hook pulls in `posthog-react-native`, and therefore React Native, which
 * a plain node test runner cannot load.
 */

/**
 * Best human-readable identity for a pressed control: an explicit label prop
 * first, else visible string content, else the accessibility label/testID.
 *
 * A blank or whitespace-only string is not a name — it would reach PostHog as
 * an empty label and make the event indistinguishable from every other press
 * of the same component.
 */
export function pressLabel(
  ...candidates: (string | null | undefined | unknown)[]
): string | null {
  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim().length > 0) {
      return candidate;
    }
  }
  return null;
}
